<template>
  <HLCardLayout :loading="app_loading" :scale="(isTabletOrPhone)?1:(isXlDevice)?0.4:0.7" :minHeight="(isSmAndUpDevice)?'600':null" :horizontalMargin="isSmAndUpDevice">
    <template #content>
		<div v-if="send_logout_error" class="pt-10">
			<h2>Leider ist ein Fehler aufgetreten.<br>Bitte probiere es noch einmal.</h2>
		</div>
    </template>
  </HLCardLayout>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import {settingsMixin} from '@/utils/settings-mixin'
import HLCardLayout from '@/components/dashboard/HLCardLayout.vue'

export default {
	components:{
		HLCardLayout
	},
	mixins: [layoutMixin,settingsMixin],
	data(){
		return {
			send_logout_error:false
		}
	},
	computed: {
		tokenByUrl(){
			return (this.$route && this.$route.query)?this.$route.query.token:null;
		}
	},
	methods:{

		logoutCurrentUser(){
			let data={
				token:this.tokenByUrl
			};
			this.send_logout_error=false;
			this.logout(data).then(()=>{
				//Success
				this.goToHome();
			}).catch((ex) => {
				this.send_logout_error=true;
				console.log(ex);
				console.log('Send error');
				this.goToHome();
			});
		}
	},
	created(){
		this.logoutCurrentUser();
	}
}
</script>

<style scoped>

</style>
